<ngx-spinner [name]="spinnerName" [fullScreen]="true"></ngx-spinner>
<div class="db-card" *libIsPlatformBrowser>
  <iframe [srcdoc]="iframeSrc | safeHtml" frameborder="0" libAutoResize (load)="iframeLoadSubject.next(frame)" #frame></iframe>
</div>
